import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { behaviourType } from 'builder/modules/interview/types'
import Spinner from 'builder/components/Spinner'
import { Navbar } from './components/Navbar/Navbar'
import { Container, SpinnerContainer, Wrapper } from './styles'
import { StartContent } from './components/StartContent/StartContent'

export interface Params {
  behaviour?: behaviourType
}
export const UnloggedUserStartView = () => {
  const { behaviour }: Params = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function userIsLogged() {
      const response = await fetch('/api/app/account', {
        cache: 'no-store',
      })

      if (response.status === 200) {
        const url = behaviour
          ? `/interview-preparation/new/${behaviour}`
          : '/interview-preparation/new'
        return navigate(`${url}${location.search}`)
      }

      trackInternalEvent('visit_test_interview', {
        label: 'interview_prep',
        parameter: behaviour || 'default',
      })

      setLoading(false)
    }

    userIsLogged()
  }, [])

  if (loading) {
    return (
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    )
  }

  return (
    <Wrapper>
      <Navbar currentStep={1} />
      <Container>
        <StartContent />
      </Container>
    </Wrapper>
  )
}
